export const tokens = {
    chip: {
        padding: 10,
        gap: 4,
        height: 28,
        fontSize: 12,
    },
    list: {
        gap: 6,
    },
};
